import * as handlers from './handlers'

const handleError = error => {
  const { status } = error.response || {}

  if (error.code === 'ECONNABORTED') {
    return handlers.handleTimeout(error)
  }

  if (!error.response) {
    return handlers.handleNoResponse(error)
  }

  if (status >= 500) {
    return handlers.handleServerError(error)
  }

  if (status >= 300 && status < 400) {
    return handlers.handleRedirect(error)
  }

  switch (status) {
    case 401: return handlers.handleUnauthorized(error)
    case 403: return handlers.handleForbidden(error)
    case 404: return handlers.handleNotFound(error)
    default: return handlers.handleBadRequest(error)
  }
}

export default handleError
